'use strict';

export default class Landing {
    constructor() {
        $('.field--name-field-loan-product-cards > .field__item').each(function (i, v) {
            const $this = $(v);
            const $imgSrc = $this.find('img').attr('src');
            const $cardTitle = $this.find('.card-title-section');

            $cardTitle.css('background-image', `url(${$imgSrc})`);
        });
    }
}
